import { render } from "./ImportUrl.vue?vue&type=template&id=09ecfb95"
import script from "./ImportUrl.vue?vue&type=script&lang=js"
export * from "./ImportUrl.vue?vue&type=script&lang=js"

import "./ImportUrl.vue?vue&type=style&index=0&id=09ecfb95&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__